import React from "react";
import ToolBar from "components/directory/members/ToolBar";
import { isEmpty, map, toNumber } from "lodash";
import DirectoryPagination from "components/directory/DirectoryPagination";
import MemberRow from "components/directory/members/MemberRow";
import { DirectoryMembership } from "components/directory/types";
import useDirectoryFilter from "../hooks/useDirectoryFilter";
import { useSearchResults } from "components/globalSearch/api";

export default function MemberListView() {
  const { filter, currentPage } = useDirectoryFilter();

  const { data, isLoading } = useSearchResults({
    module: "memberships",
    ...filter,
  });
  const queryData = data?.memberships_query;

  return (
    <div className="flex flex-col gap-y-4">
      <ToolBar isLoading={isLoading} filter={filter} />
      <DirectoryPagination
        currentPage={toNumber(currentPage)}
        pagination={
          queryData && {
            total: queryData.total,
            page: queryData.page,
            per_page: queryData.per,
          }
        }
        isLoading={isLoading}
      >
        {!isEmpty(queryData?.hits)
          ? map(queryData?.hits, (member: DirectoryMembership) => (
              <MemberRow key={member.id} {...member} />
            ))
          : I18n.t("js.directory.empty_collection")}
      </DirectoryPagination>
    </div>
  );
}
